import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Graceful fallback when Supabase is not configured
const isConfigured = supabaseUrl && supabaseAnonKey &&
  !supabaseUrl.includes('YOUR_') && !supabaseAnonKey.includes('YOUR_');

export const supabase = isConfigured
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

export const isSupabaseConfigured = () => isConfigured;
